import React, { Component } from 'react'
import styles from './Victual.css';

const CURRENCY = '$';
let quantityCounter = 0;
let priceCounter = 0;
let mapOfOrders = new Map() 

class Victual extends Component {
	state = { order: 0 }

	AddOrder = () => {
		// Clear order textarea
		this.updateOrders('add');
		// Handle change in quantity and Price
		this.handleQuantityPrice('add')
	}

	DecOrder = () => {
		if (this.state.order > 0) {
			this.updateOrders('dec');
			this.handleQuantityPrice('dec');
		}
	}

	updateOrders = (addOrDec) => {
		const orderArea = document.getElementsByName('order')[0];
		orderArea.value = ''; // Clear order textarea
		let orderValue = '';
		switch (addOrDec) {
			case 'add':
				this.setState(state => ({ order: state.order += 1 }))
				mapOfOrders.set(this.props.name, this.state.order + 1); // add or update new orders
				break;
			case 'dec':
				this.setState(state => ({ order: state.order -= 1 })); // decrease state if order bigger than 0
				mapOfOrders.set(this.props.name, this.state.order - 1); 
				mapOfOrders.get(this.props.name) === 0 ? mapOfOrders.delete(this.props.name) : null; // remove or update new orders
				break;
			default: console.log("error while updating orders"); break;
		}
		for (var [name, numOfOrders] of mapOfOrders.entries()) {
			orderValue += `${name} x ${numOfOrders}\n`; // 
		}
		orderArea.value = orderValue; // Parse down orders to the textArea
	}
	handleQuantityPrice = (addOrDec) => {
		const quantity = document.getElementsByName('quantity')[0];
		const price = document.getElementsByName('price')[0];
		switch (addOrDec) {
			case 'add':
				//Quantity
				quantityCounter += 1;
				quantity.value = quantityCounter;
				//Price
				priceCounter += Number(this.props.price);
				price.value = priceCounter.toFixed(2) + CURRENCY;
				break;
			case 'dec':
				//quantity
				quantityCounter -= 1;
				quantity.value = quantityCounter;
				//price
				priceCounter -= Number(this.props.price);
				price.value = priceCounter.toFixed(2) + CURRENCY;
				break;
			default: console.log("error while updating orders"); break;
 
		}
	}

	render() {
		return (
			<div>
				<div className={styles.victual}>
					<div className='name-desc'>
						<div className={styles.name}>{this.props.name}</div>
						<div className={styles.desc}>{this.props.desc}</div>
					</div>
					<div className={styles.order}>
						<div className={styles.price}>{this.props.price}{CURRENCY}</div>
						<button className={styles.dec}
							onClick={this.DecOrder}>-</button>
						<div className={styles.orderNumber}>{this.state.order}</div>
						<button className={styles.inc}
							onClick={this.AddOrder}>+</button>
					</div>
				</div>
			</div>
		)
	}
}


export default Victual;





// WEBPACK FOOTER //
// ./src/components/Menu/Victual/Victual.js